import { createSelector } from '@ngrx/store';

import { IAppState } from '../state/app.state';
import { IIdentifyState } from '../state/identify.state';

const identifyState = (state: IAppState) => state.identify;

export const selectIdentify = createSelector(
  identifyState,
  (state: IIdentifyState) => state.identify
);
